 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		45: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		45: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-locations-LocationsPage-LocationsPageContainer","39":"app-components-search-Search-SearchContainer","40":"app-components-search-SearchPrintList-SearchPrintListContainer","41":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","42":"app-components-shelves-Shelf-ShelfContainer","43":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","44":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"cebb2dcd37467083692f","1":"1983881508485e3fcb55","2":"441729314393ec7f810c","3":"3755c1f9d047536a832c","4":"8aca775cd700102e2624","5":"e996c39e6cfb3b556d90","6":"91d036b9e0b4b5238755","7":"b3d29e029def8578e74c","8":"c75003d7c40a0d9b5d49","9":"b468a5b7dd2127728aaf","10":"40222b37a963aaa31c7a","11":"db7ff32a121f8fc96928","12":"a15e6c819ae4da183fa0","13":"f206b6210d4d288e2694","14":"91de7f906f419c089ec4","15":"b594411110920eb54a3d","16":"cbb300146aff682bbf22","17":"4e832feaa36b16a9d5eb","18":"43892f486f86aa6822ad","19":"a48a3e5b5b277c80e4da","20":"4782094572a3b6012d57","21":"fbc9c951bbbd3a16e905","22":"9897c59efc2efc90a158","23":"0621aab2a8f0476cab46","24":"c9891350544eb7fe1121","25":"5577c8b6c1244acb93c6","26":"ec15ae3736f1b20ad3d1","27":"4e85c356ff61874e5a49","28":"ab3c0f181d752b1745a0","29":"cd136fc2941331de32e2","30":"161c1591fcd54ff7f06d","31":"e5d50d75468c47996aaf","32":"2cf87dd3ed5621dc7c63","33":"6670cbba30e0dd67ffb1","34":"033eb5b362415b1cd49d","35":"004ebf5f1115d1254ba9","36":"693b62de389e46d1cf46","37":"ecc3c1be49dbe687b1bf","38":"2413c396f4f67d376894","39":"ebd9359b4560787883c9","40":"1aa93e5b4981e8c061d7","41":"fd04aeac8c6a102c128d","42":"62bc7b083e2554db368d","43":"bab3f3a1c7db232063ea","44":"382f18cba369c73bf12c","46":"ac82747c8ea6bf2de193","47":"9106462149e9dd73705a","48":"607ddd0183743fcad935","49":"7a41e5c04dba45b3ded0","50":"b92c8096bf0316e0c9c5","51":"65635298fba96b076ebc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-locations-LocationsPage-LocationsPageContainer","39":"app-components-search-Search-SearchContainer","40":"app-components-search-SearchPrintList-SearchPrintListContainer","41":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","42":"app-components-shelves-Shelf-ShelfContainer","43":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","44":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"cebb2dcd37467083692f","1":"1983881508485e3fcb55","2":"441729314393ec7f810c","3":"3755c1f9d047536a832c","4":"8aca775cd700102e2624","5":"e996c39e6cfb3b556d90","6":"91d036b9e0b4b5238755","7":"b3d29e029def8578e74c","8":"c75003d7c40a0d9b5d49","9":"b468a5b7dd2127728aaf","10":"40222b37a963aaa31c7a","11":"db7ff32a121f8fc96928","12":"a15e6c819ae4da183fa0","13":"f206b6210d4d288e2694","14":"91de7f906f419c089ec4","15":"b594411110920eb54a3d","16":"cbb300146aff682bbf22","17":"4e832feaa36b16a9d5eb","18":"43892f486f86aa6822ad","19":"a48a3e5b5b277c80e4da","20":"4782094572a3b6012d57","21":"fbc9c951bbbd3a16e905","22":"9897c59efc2efc90a158","23":"0621aab2a8f0476cab46","24":"c9891350544eb7fe1121","25":"5577c8b6c1244acb93c6","26":"ec15ae3736f1b20ad3d1","27":"4e85c356ff61874e5a49","28":"ab3c0f181d752b1745a0","29":"cd136fc2941331de32e2","30":"161c1591fcd54ff7f06d","31":"e5d50d75468c47996aaf","32":"2cf87dd3ed5621dc7c63","33":"6670cbba30e0dd67ffb1","34":"033eb5b362415b1cd49d","35":"004ebf5f1115d1254ba9","36":"693b62de389e46d1cf46","37":"ecc3c1be49dbe687b1bf","38":"2413c396f4f67d376894","39":"ebd9359b4560787883c9","40":"1aa93e5b4981e8c061d7","41":"fd04aeac8c6a102c128d","42":"62bc7b083e2554db368d","43":"bab3f3a1c7db232063ea","44":"382f18cba369c73bf12c","46":"ac82747c8ea6bf2de193","47":"9106462149e9dd73705a","48":"607ddd0183743fcad935","49":"7a41e5c04dba45b3ded0","50":"b92c8096bf0316e0c9c5","51":"65635298fba96b076ebc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2335);
